export enum ECanceledByUser {
  PATIENT = 'PATIENT',
  CLINIC = 'CLINIC',
  SYSTEM = 'SYSTEM'
}
